export default __webpack_public_path__ + "static/media/Icon_Folder_01.8c343f9b.svg";